import { ApplicationInsights } from '@microsoft/1ds-analytics-web-js';
import { AuthPlugin, AuthType } from '@microsoft/1ds-auth-js';
import * as appConfig from '@shared/services/init/appConfig';
import { PropertiesPlugin } from '@microsoft/1ds-properties-js';
import { CorrelationVectorPlugin } from '@microsoft/1ds-cv-js';
import { getWindow } from '@shared/services/window';
import { Constants, Environment, OneDSEnvs } from '@shared/utils/constants';
import { getGPCValue } from '@shared/utils/privacyUtils';
import { scrubField } from '@shared/utils/scrubbingUtils';
const envsMap = {
    [Environment.Production]: OneDSEnvs.Production,
    [Environment.Canary]: OneDSEnvs.Canary,
    [Environment.Development]: OneDSEnvs.Internal,
    [Environment.Dogfood]: OneDSEnvs.Dogfood,
    [Environment.Test]: OneDSEnvs.Test
};
const getEnvName = ()=>{
    var _getWindow___INITIAL_STATE___config_siteEnvironment, _getWindow___INITIAL_STATE___config, _getWindow___INITIAL_STATE__, _getWindow;
    var _getWindow___INITIAL_STATE___config_siteEnvironment_toLowerCase;
    const siteEnvironment = (_getWindow___INITIAL_STATE___config_siteEnvironment_toLowerCase = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow___INITIAL_STATE__ = _getWindow.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__ === void 0 ? void 0 : (_getWindow___INITIAL_STATE___config = _getWindow___INITIAL_STATE__.config) === null || _getWindow___INITIAL_STATE___config === void 0 ? void 0 : (_getWindow___INITIAL_STATE___config_siteEnvironment = _getWindow___INITIAL_STATE___config.siteEnvironment) === null || _getWindow___INITIAL_STATE___config_siteEnvironment === void 0 ? void 0 : _getWindow___INITIAL_STATE___config_siteEnvironment.toLowerCase()) !== null && _getWindow___INITIAL_STATE___config_siteEnvironment_toLowerCase !== void 0 ? _getWindow___INITIAL_STATE___config_siteEnvironment_toLowerCase : process.env.siteEnvironment;
    const env = envsMap[`${siteEnvironment}`];
    if (!env) {
        throw new Error('failed to load env name for telemetry');
    }
    return env;
};
const initiate1DS = ()=>{
    var _getWindow_document, _getWindow, _getWindow___INITIAL_STATE___config, _getWindow___INITIAL_STATE__, _getWindow1, _getWindow___INITIAL_STATE___config1, _getWindow___INITIAL_STATE__1, _getWindow2;
    const analytics = new ApplicationInsights();
    const authPlugin = new AuthPlugin();
    const propertiesPlugin = new PropertiesPlugin();
    const cvPlugin = new CorrelationVectorPlugin();
    analytics.addTelemetryInitializer((envelope)=>{
        var _envelope_baseData, _envelope_data, _envelope_baseData1, _envelope_data_baseData, _envelope_data1, _envelope_baseData2, _envelope_baseData3, _envelope_data2;
        if (envelope === null || envelope === void 0 ? void 0 : (_envelope_baseData = envelope.baseData) === null || _envelope_baseData === void 0 ? void 0 : _envelope_baseData.target) {
            envelope.baseData.target = scrubField(envelope.baseData.target);
        }
        if (envelope === null || envelope === void 0 ? void 0 : (_envelope_data = envelope.data) === null || _envelope_data === void 0 ? void 0 : _envelope_data.uri) {
            envelope.data.uri = scrubField(envelope.data.uri);
        }
        if (envelope === null || envelope === void 0 ? void 0 : (_envelope_baseData1 = envelope.baseData) === null || _envelope_baseData1 === void 0 ? void 0 : _envelope_baseData1.uri) {
            envelope.baseData.uri = scrubField(envelope.baseData.uri);
        }
        if (envelope === null || envelope === void 0 ? void 0 : (_envelope_data1 = envelope.data) === null || _envelope_data1 === void 0 ? void 0 : (_envelope_data_baseData = _envelope_data1.baseData) === null || _envelope_data_baseData === void 0 ? void 0 : _envelope_data_baseData.uri) {
            envelope.data.baseData.uri = scrubField(envelope.data.baseData.uri);
        }
        if (envelope === null || envelope === void 0 ? void 0 : (_envelope_baseData2 = envelope.baseData) === null || _envelope_baseData2 === void 0 ? void 0 : _envelope_baseData2.targetUri) {
            envelope.baseData.targetUri = scrubField(envelope.baseData.targetUri);
        }
        if (envelope === null || envelope === void 0 ? void 0 : (_envelope_baseData3 = envelope.baseData) === null || _envelope_baseData3 === void 0 ? void 0 : _envelope_baseData3.refUri) {
            envelope.baseData.refUri = scrubField(envelope.baseData.refUri);
        }
        if (envelope === null || envelope === void 0 ? void 0 : (_envelope_data2 = envelope.data) === null || _envelope_data2 === void 0 ? void 0 : _envelope_data2.refUri) {
            envelope.data.refUri = scrubField(envelope.data.refUri);
        }
    });
    const webAnalyticsConfig = {
        urlCollectQuery: true,
        urlCollectHash: true,
        // Web Analytics Plugin configuration
        autoCapture: {
            scroll: true,
            pageView: true,
            onLoad: true,
            onUnload: true,
            click: true,
            resize: true,
            lineage: true,
            jsError: true
        },
        coreData: {
            referrerUri: scrubField((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_document = _getWindow.document) === null || _getWindow_document === void 0 ? void 0 : _getWindow_document.referrer)
        },
        shareAuthStatus: true,
        callback: {
            signedinStatus: ()=>{
                var _getWindow___INITIAL_STATE___users, _getWindow___INITIAL_STATE__, _getWindow;
                var _getWindow___INITIAL_STATE___users_signedIn;
                return (_getWindow___INITIAL_STATE___users_signedIn = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow___INITIAL_STATE__ = _getWindow.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__ === void 0 ? void 0 : (_getWindow___INITIAL_STATE___users = _getWindow___INITIAL_STATE__.users) === null || _getWindow___INITIAL_STATE___users === void 0 ? void 0 : _getWindow___INITIAL_STATE___users.signedIn) !== null && _getWindow___INITIAL_STATE___users_signedIn !== void 0 ? _getWindow___INITIAL_STATE___users_signedIn : false;
            }
        }
    };
    const authConfig = {
        authType: AuthType.AAD,
        loggedInStatusCallback: ()=>{
            var _getWindow___INITIAL_STATE___users, _getWindow___INITIAL_STATE__, _getWindow;
            var _getWindow___INITIAL_STATE___users_signedIn;
            return (_getWindow___INITIAL_STATE___users_signedIn = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow___INITIAL_STATE__ = _getWindow.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__ === void 0 ? void 0 : (_getWindow___INITIAL_STATE___users = _getWindow___INITIAL_STATE__.users) === null || _getWindow___INITIAL_STATE___users === void 0 ? void 0 : _getWindow___INITIAL_STATE___users.signedIn) !== null && _getWindow___INITIAL_STATE___users_signedIn !== void 0 ? _getWindow___INITIAL_STATE___users_signedIn : false;
        }
    };
    var _getGPCValue;
    const propertiesPluginConfig = {
        populateBrowserInfo: true,
        populateOperatingSystemInfo: true,
        enableApplicationInsightsTrace: true,
        enableApplicationInsightsUser: true,
        userConsentCookieName: Constants.Cookies.privacyConsentAcceptedDate,
        env: getEnvName(),
        // eslint-disable-next-line camelcase
        gpcDataSharingOptIn: (_getGPCValue = getGPCValue()) !== null && _getGPCValue !== void 0 ? _getGPCValue : true,
        callback: {
            userConsentDetails: ()=>appConfig.get('siteConsent')
        }
    };
    const consent = appConfig.get('siteConsent');
    const hasConsent = consent ? !consent.Required || consent.Analytics : false;
    const config = {
        propertyConfiguration: propertiesPluginConfig,
        instrumentationKey: (_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : (_getWindow___INITIAL_STATE__ = _getWindow1.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__ === void 0 ? void 0 : (_getWindow___INITIAL_STATE___config = _getWindow___INITIAL_STATE__.config) === null || _getWindow___INITIAL_STATE___config === void 0 ? void 0 : _getWindow___INITIAL_STATE___config.telemetryInstrumentationKey,
        endpointUrl: (_getWindow2 = getWindow()) === null || _getWindow2 === void 0 ? void 0 : (_getWindow___INITIAL_STATE__1 = _getWindow2.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__1 === void 0 ? void 0 : (_getWindow___INITIAL_STATE___config1 = _getWindow___INITIAL_STATE__1.config) === null || _getWindow___INITIAL_STATE___config1 === void 0 ? void 0 : _getWindow___INITIAL_STATE___config1.telemetryEndpoint,
        webAnalyticsConfiguration: webAnalyticsConfig,
        extensions: [
            authPlugin,
            propertiesPlugin,
            cvPlugin
        ],
        extensionConfig: {
            [authPlugin.identifier]: authConfig,
            [propertiesPlugin.identifier]: propertiesPluginConfig
        },
        perfEvtsSendAll: true,
        // Disable cookies until consent is granted
        disableCookiesUsage: !hasConsent
    };
    analytics.initialize(config, []);
    return analytics;
};
export default (()=>__CLIENT__ && initiate1DS());
